export function statusFromExpiry(expiry) {
  if (!expiry) return "valid";
  const d = new Date(expiry);
  if (isNaN(d)) return "valid";
  const today = new Date();
  today.setHours(0,0,0,0);
  const diff = Math.floor((d - today) / (1000 * 60 * 60 * 24));
  if (diff < 0) return "expired";
  if (diff <= 60) return "expiring";
  return "valid";
}

export function statusLabel(s) {
  return s === "expired" ? "Scaduto" : s === "expiring" ? "In scadenza" : "Valido";
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (isNaN(d)) return s;
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return s; }
}

export function fmtDateTime(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleString("it-IT");
  } catch { return s; }
}

export const COMPANY_DOC_CATEGORIES = [
  "Nomina Addetto Antincendio",
  "Attestato Addetto Antincendio",
  "Nomina Addetto Primo Soccorso",
  "Attestato Addetto Primo Soccorso",
  "Nomina Medico Competente",
  "Nomina Preposto",
  "Attestato Preposto",
  "Nomina RLS",
  "Attestato RLS",
  "Nomina RSPP",
  "Attestato RSPP",
  "Visura Camerale",
  "DOMA",
  "DURC",
  "DVR",
  "Documento identità Amministratore",
  "Documento identità Titolare",
  "Polizza assicurativa",
  "Attestazione SOA",
  "Altro documento aziendale",
];

export const WORKER_DOC_CATEGORIES = [
  "Documento di identità",
  "UNILAV",
  "Attestato formazione generale",
  "Attestato formazione specifica",
  "Attestato lavori in quota",
  "Attestato preposto",
  "Attestato addetto antincendio",
  "Attestato addetto primo soccorso",
  "Attestato RSPP/RLS",
  "Verbale consegna DPI",
  "Idoneità sanitaria",
  "Altro attestato",
];

export const SITE_DOC_CATEGORIES = [
  "POS - Piano Operativo di Sicurezza",
  "PSC - Piano di Sicurezza e Coordinamento",
  "Ricezione e accettazione PSC",
  "Dichiarazione art. 14 D.Lgs. 81/2008",
  "Documentazione attrezzature",
  "Documentazione macchinari",
  "Verbale di cantiere",
  "Altro documento cantiere",
];

export const EQUIPMENT_DOC_CATEGORIES = [
  "Manuale uso e manutenzione",
  "Dichiarazione CE di conformità",
  "Verifica periodica",
  "Verbale di verifica",
  "Manutenzione",
  "Altro documento attrezzatura",
];

export const isStudio = (u) => u?.role === "studio";
export const canManage = (u) => ["admin", "operatore"].includes(u?.role);
export const canUpload = (u) => canManage(u) || (isStudio(u) && !!u?.permessi?.upload);
export const canDownload = (u) => ["admin", "operatore", "visualizzatore"].includes(u?.role) || (isStudio(u) && !!u?.permessi?.download);
